module.exports = __webpack_public_path__ + "img/logo_en.6d888d06.png";